var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConfirmation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#08D48B",
  fillRule: "nonzero",
  d: "M12.351 24C5.487 24 0 18.738 0 12.351 0 5.373 5.373 0 12.351 0 18.738 0 24 5.487 24 12.351 24 18.627 18.627 24 12.351 24m0-.837c5.814 0 10.812-4.998 10.812-10.812C23.163 5.942 18.267.837 12.35.837 5.835.837.837 5.835.837 12.351c0 5.916 5.105 10.812 11.514 10.812m-1.708-9.122 5.122-5.626.825.751-5.859 6.436-3.145-2.753.735-.84z"
})));
export { SvgConfirmation as ReactComponent };
export default __webpack_public_path__ + "static/media/confirmation.547a1b18.svg";